
import { defineComponent, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useToast } from 'vue-toastification';
import { fwp } from '@/lib/vault/bn';
import { showTokenBalance } from '@/lib/vault/farmVaultUtils';

export default defineComponent({
  components: {},

  props: {
    farmVault: { type: Object },
  },

  setup(props) {
    const { t } = useI18n();
    const toast = useToast();

    // DATA
    const showBoostDetail = ref(false);
    const dataShow = ref([
      {
        label: 'vault_boosting',
        value: 'userBalanceVaultInToken',
      },
      {
        label: 'nft_effective_boost',
        value: 'nftEffectiveBoost',
      },
      {
        label: 'total_stake_in_nft',
        value: 'totalStakeInNft',
      },
      {
        label: 'overall_boosting',
        value: 'nftOverallBoost',
      },
    ]);

    // METHOD
    const forceBoost = async () => {
      try {
        await props.farmVault?.farm.deposit(0);
        props.farmVault?.farm.updateAll();
      } catch (error) {
        console.error(error);
        toast.error(t('alert_force_new_boost_error'));
      }
    };

    return {
      fwp,
      showTokenBalance,
      // data
      showBoostDetail,
      dataShow,
      // method
      forceBoost,
    };
  },
});
